<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_lock"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                ACL Model <i class="icon icon-icon_arrow-right"></i> Create
                            </span>
                            <h1>Nouveau</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>
                    <main>
                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">
                                <form-select label="Model" multiple="false" v-model="resource.model" :options="permissions"></form-select>
                                <acl-authorizations v-if="resource.model" v-model="resource.acl" :model="resource.model.id"></acl-authorizations>
                            </tab>
                        </tabs>
                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import Create from '../../../layouts/Create.vue';
    import AclModelService from './AclModelService.js';

    export default {
        extends: Create,
        data () {
            return {
                className: '',
                profile: {},
                resource: {
                    acl: [],
                    model: null
                },
                permissions: [],
                existingPermission: []
            }
        },
        mounted: function(){
            this.initialize()
        },
        methods:{
            initialize: function(){
                let self = this;
                AclModelService.query().then(response => {
                    $.each( response.data, function(key, value) {
                        self.existingPermission.push(value.model_name);
                    });
                    AclModelService.getAllPermissions().then(response => {
                        $.each( response.data, function(key, value) {
                            if( self.existingPermission.indexOf(value.model) === -1 ){
                                let modelName = value.model.split('\\').pop()
                                let modelId = value.model.split('\\').join('.')
                                self.permissions.push({id:modelId, name:value.model});
                            }
                        });
                    });
                });
            },
            submit: function(){
                this.resource._axioMessageSuccess = true;
                AclModelService.create(this.resource).then((response) => {
                    this.$router.push({ name: 'acl' });
                    this.$emit('refresh', this);
                });
            },
            back: function(){
                let self = this
                if( this.className == "" ){
                    self.$router.push({name: 'acl'});
                }
            }
        },
        watch: {
            'resource.acl'(newVal, oldVal) {
                console.log('REOURCES', this.resource);
                console.log('REOURCE OLD VALUE', oldVal);
                console.log('REOURCE NEW VALUE', newVal);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/authorizations/Create.vue